import { drama } from '../../../constants/actionTypes';

const initState = {};

export default (state = initState, { type, entities }) => {
  switch (type) {
    case drama.FETCH_DRAMA_COMMENTS_SUCCESS:
    case drama.FETCH_DRAMA_PINNED_COMMENTS_SUCCESS:
    case drama.POST_DRAMA_COMMENT_SUCCESS:
    case drama.FETCH_DRAMA_REPLIES_SUCCESS:
    case drama.POST_DRAMA_REPLY_SUCCESS:
      return entities.replies ? { ...state, ...entities.replies } : state;

    case drama.CLEAN_COMMENTS:
      return initState;

    default:
      return state;
  }
};
